import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function formReducer(state = initialState.maxId, action: any) {
  switch (action.type) {
    case types.SAVE_MAXID_SUCCESS:
      return action.maxId;
    default:
      return state;
  }
}
